import { defineComponent as _defineComponent } from 'vue'
import ContextMenu from '@/components/ui/contextMenu/ContextMenu.vue'
import { ShareFireOutbreakAlertEnum } from '../enums/ShareFireOutbreakAlert.enum'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireOubreakCardMenu',
  props: {
    seen: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'change', value: ShareFireOutbreakAlertEnum): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	seen: boolean
};





const options = [
	{
		name: 'Compartilhar no Whatsapp',
		icon: 'ic:baseline-whatsapp',
		event: ShareFireOutbreakAlertEnum.WHATSAPP,
	},
]

const iconColor = computed(() => (props.seen ? 'text-blue-base' : 'text-red-danger'))

return { __sfc: true,props, emit, options, iconColor, ContextMenu }
}

})